<template>
  <div class="w-full" style="position: relative">
    <a-spin :spinning="spinning">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-row type="flex">
          <a-col :span="24">
            <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 21, offset: 1 }">
              <a-divider orientation="left" class="pl-9">申请人信息</a-divider></a-form-item
            >
          </a-col>
          <a-col :span="12">
            <a-form-item label="申请企业全称">
              <a-auto-complete
                v-decorator="['bidder', { rules: [{ required: true, message: '请输入企业名称' }] }]"
                :dataSource="companySearchs"
                @search="(v) => onCompanySearch(v)"
                @select="(_, option) => companySelect(option)"
                style="width: 100%"
              >
                <a-textarea placeholder="请输入企业名称" autoSize />
              </a-auto-complete>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="社会信用代码">
              <a-input
                v-decorator="[
                  'taxNumber',
                  { rules: [{ required: true, message: '请输入社会信用代码' }] },
                ]"
                placeholder="请输入社会信用代码"
                :disabled="disabled"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="企业地址">
              <a-input
                v-decorator="[
                  'companyAddress',
                  { rules: [{ required: false, message: '请输入企业地址' }] },
                ]"
                placeholder="请输入企业地址"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="企业电话">
              <a-input
                v-decorator="['tel', { rules: [{ required: false, message: '请输入企业电话' }] }]"
                placeholder="请输入企业电话"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-row type="flex">
              <a-col :span="6">
                <a-form-item label="营业执照" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <div class="overflow-hidden">
                    <a-input v-show="false" v-decorator="['license']"></a-input>
                    <Upload
                      class="scaled-upload"
                      :src="companyinfo.license"
                      @upload="licenseUpload"
                      :disabled="isdisabled('license')"
                    ></Upload>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="开户许可证" :label-col="{ span:12 }" :wrapper-col="{ span: 12 }">
                  <div class="overflow-hidden">
                    <a-input v-show="false" v-decorator="['certificate_src']"></a-input>
                    <Upload
                      class="scaled-upload"
                      :src="companyinfo.certificate_src"
                      @upload="certUpload"
                      :disabled="isdisabled('certificate_src')"
                    ></Upload>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="资质证书" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <div class="overflow-hidden">
                    <Upload
                      class="scaled-upload"
                      :src="companyinfo.qualification_src"
                      @upload="qualificationUpload"
                      :disabled="isdisabled('qualification_src')"
                    ></Upload>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="法人身份证" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                  <div class="overflow-hidden">
                    <Upload
                      class="scaled-upload"
                      :disabled="isdisabled('id_card')"
                      :src="companyinfo.id_card"
                      @upload="id_cardUpload"
                    ></Upload>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="24">
            <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 21, offset: 1 }">
              <a-divider orientation="left" class="pl-9">项目信息</a-divider></a-form-item
            >
          </a-col>
          <a-col :span="24">
            <a-form-item label="项目名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
              <a-input
                v-decorator="[
                  'project',
                  { rules: [{ required: true, message: '请输入项目名称' }] },
                ]"
                placeholder="请输入项目名称"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="业主名称">
              <a-input v-decorator="['landlord']" placeholder="请输入业主名称" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="业主地址">
              <a-input v-decorator="['landlord_address']" placeholder="请输入业主地址" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="受益人名称">
              <a-input
                v-decorator="[
                  'proprietor',
                  { rules: [{ required: true, message: '请输入受益人名称' }] },
                ]"
                placeholder="请输入受益人名称"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="项目所在地">
              <a-input
                v-decorator="[
                  'proprietor_address',
                  { rules: [{ required: true, message: '请输入项目所在地' }] },
                ]"
                placeholder="请输入项目所在地"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保函类型">
              <a-select
                v-decorator="[
                  'category_id',
                  { rules: [{ required: true, message: '请选择保函类型' }] },
                ]"
                :options="categorize_data"
                @select="categorySelect"
                placeholder="请选择保函类型"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同金额(元)">
              <a-input-number
                v-decorator="[
                  'contract_amount',
                  { rules: [{ required: true, message: '请输入合同金额(元)' }] },
                ]"
                placeholder="请输入合同金额(元)"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="担保金额(元)">
              <a-input-number
                v-decorator="[
                  'money',
                  { rules: [{ required: true, message: '请输入担保金额(元)' }] },
                ]"
                @change="updatePoundage"
                placeholder="请输入担保金额(元)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保函期限(月)">
              <a-input-number
                :precision="0"
                v-decorator="[
                  'effect_month',
                  { rules: [{ required: true, message: '请输入保函期限(月)' }] },
                ]"
                @change="updatePoundage"
                placeholder="请输入保函期限(月)"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="保函模版 " :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <a-radio-group
                name="temp_name"
                :default-value="1"
                @change="stepRadio"
                v-model="stepRadioValue"
              >
                <a-radio :value="1"> 固定模版 </a-radio>
                <a-radio :value="2"> 自定义模版 </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              label="选择模版"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 12 }"
              v-if="tempFlage"
            >
              <div class="flex items-center">
                <div class="flex-grow">
                  <a-select
                    v-decorator="[
                      'temp_id',
                      { rules: [{ required: true, message: '请选择模版' }] },
                    ]"
                    :options="temp_data"
                    placeholder="请选择模版"
                    @change="selectStepTempChange"
                  >
                  </a-select
                ></div>
              </div>
            </a-form-item>
            <a-form-item
              label="模版名称"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 12 }"
              v-else
            >
              <div>
                <div
                  ><a :href="previewlink($ossUrl + pd.customize_temp_src)" target="__blank">{{
                    pd.customize_temp_src
                  }}</a></div
                >
                <a-upload
                  :before-upload="beforeUpload"
                  :customRequest="api2"
                  accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
                  :show-upload-list="false"
                  v-decorator="[
                    'customize_temp_src',
                    { rules: [{ required: true, message: '请选择模版名称' }] },
                  ]"
                >
                  <a-button :icon="loading ? 'loading' : 'plus'">上传</a-button>
                </a-upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预估保费(元) ">
              <a-input-number
                v-decorator="[
                  'poundage',
                  { rules: [
                    { required: tempFlage, message: '请输入预估保费(元)' },
                    { validator: this.validatePoundage }                  
                  ] },
                ]"
                :min="minPoundage"
                placeholder="请输入预估保费(元)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="项目合同">
              <FileUpload
                :src="fileinfo.project_contract" 
                :name="fileinfo.project_contract_name"
                @upload="(e) => uploadFile(e, 'project_contract')"
                accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
              ></FileUpload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="中标通知书">
              <FileUpload
                :src="fileinfo.bidding_file" 
                :name="fileinfo.bidding_file_name"
                @upload="(e) => uploadFile(e, 'bidding_file')"
                accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
              ></FileUpload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="其他文件">
              <FileUpload
                :src="fileinfo.other_file" 
                :name="fileinfo.other_file_name"
                @upload="(e) => uploadFile(e, 'other_file')"
                accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
              ></FileUpload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系人 ">
              <a-input v-decorator="['sendName']" placeholder="请输入联系人" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系号码">
              <a-input v-decorator="['telephone']" placeholder="请输入联系号码" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="推荐码">
              <a-input v-decorator="['r_code']" placeholder="请输入推荐码" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="费率" v-show="false">
              <a-input-number
                v-decorator="['rate']"
                disabled
                placeholder="请输入预估保费(元)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="公司" v-show="false">
              <a-input-number
                v-decorator="['company']"
                disabled
                placeholder="请输入预估保费(元)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="模版最低担保费" v-show="false">
              <a-input-number
                v-decorator="['tempmoney']"
                disabled
                placeholder="请输入模版担保费(元)"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 24, offset: 15 }">
              <a-button type="primary" html-type="submit">下一步</a-button>
              <a-button class="ml-3" @click="reset">重置</a-button>
              <a-button type="primary" class="ml-3" @click="preview" v-if="pd.temp_id > 0">保函格式预览</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <a-modal
      title="保函格式预览"
      :visible="previewFlag"
      :footer="null"
      @cancel="previewFlag = false"
      forceRender
      width="842px"
      :bodyStyle="{ padding: 0 }"
    >
      <content-preview :content="content"></content-preview>
    </a-modal>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { companysByProject, companyCertificateModify } from '@/api/company';
  import { other_category_temps, temps } from '@/api/temp';
  import { otherDoContract } from '@/api/contract';
  import { previewlink } from '@/utils/tool';
  import { message } from 'ant-design-vue';
  import { licenseocr, cert_ocr, ggbCompanysava } from '@/api/company';
  import Upload from '@/components/Upload/index';
  import FileUpload from '@/components/FileUpload/index';
  import ContentPreview from '@/components/ContentPreview/index';
  import { pick } from 'lodash';
  import { transContentO } from '@/utils/transContent';
  export default {
    components: { Upload, FileUpload, ContentPreview },
    props: {
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        spinning: false,
        pd: { company_id: undefined, customize_temp_src: '', id: 0 },
        companySearchs: [],
        categorize_data: [],
        temp_data: [],
        tempFlage: true,
        companyinfo: { id: 0, qualification_src: '' },
        loading: false,
        disabled: false,
        onCompanySearch: debounce(this.companysearch, 500),
        stepRadioValue: 1,
        content: '',
        previewFlag: false,
        tempmoney: 0,
        minPoundage: 0,
        fileinfo: {},
        licenseocrres: {},
        certocrres: {}
      };
    },
    computed: {},
    beforeCreate() {
      this.form = this.$form.createForm(this, {
        name: 'step1',
        // onValuesChange:(props, value, values) => {
        //   if (
        //     (value.money || value.temp_id || value.effect_month) &&
        //     values.money != undefined &&
        //     values.temp_id != undefined &&
        //     values.effect_month != undefined
        //   ) {
        //     let pay = Math.ceil(
        //       parseFloat((values.money * values.effect_month * values.rate) / 1200),
        //     );
        //     this.minPoundage = pay > values.tempmoney ? pay : values.tempmoney;
        //     props.form.setFieldsValue({ poundage: this.minPoundage });
        //   }
        // },
      });
    },
    watch: {
      ct(a) {},
    },
    async mounted() {
      this.categorize_data =
        (
          await other_category_temps({
            qp: JSON.stringify({ eq: { review: 1 } }),
            orderby: 'a.sort desc',
          })
        ).data.map((e) => {
          return { label: e.name, value: e.id };
        }) || [];
        this.form.setFieldsValue({ company: this.companyinfo });
      // this.temp_data =
      //   (
      //     await temps({
      //       qp: JSON.stringify({ eq: { review: 1 }, ne: { category_ids: '2' } }),
      //       orderby: 'a.sort desc',
      //     })
      //   ).data.map((e) => {
      //     return { label: e.name, value: e.id, id: e.id, rate: e.rate, content_2: e.content_2 };
      //   }) || [];
    },

    methods: {
      previewlink,
      async categorySelect(e) {
        this.temp_data =
          (
            await temps({
              qp: JSON.stringify({ eq: { review: 1, category_ids: e } }),
              orderby: 'a.sort desc',
            })
          ).data.map((e) => {
            return {
              label: e.name,
              value: e.id,
              id: e.id,
              rate: e.rate,
              content_2: e.content_2,
              money: e.money,
            };
          }) || [];
      },
      getContent() {
        let temp = this.temp_data.find((e) => {
          return e.id == this.pd.temp_id;
        });
        let c = '';
        if (temp) {
          c = temp.content_2;
          let value = this.form.getFieldsValue();
          value = Object.assign({}, this.pd, value);
          c = transContentO(c, value);
        }
        return c;
      },
      preview() {
        this.form.validateFields().then(() => {
          this.content = this.getContent();
          this.previewFlag = true;
        });
      },
      async certUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ certificate_src: res.pathname }), 1);
          this.certocrres = await cert_ocr(res.id);
          console.log(this.certocrres);
          let ocrrespick = pick(this.certocrres, ['bankAccount', 'bankName']);
          this.companyinfo.bankAccount = ocrrespick.bankAccount;
          this.companyinfo.bankName = ocrrespick.bankName;
          // if (this.licenseocrres.owner && this.licenseocrres.owner != this.certocrres.owner) {
          //   this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
          // }
        } catch (error) {
          this.$message.error(error);
        }
        this.companyinfo.certificate_id = res.id;
        this.companyinfo.certificate_src = res.pathname;
      },
      async qualificationUpload(res) {
        this.companyinfo.qualification_src = res.pathname;
      },
      async id_cardUpload(res) {
        this.companyinfo.id_card = res.pathname;
      },
      async licenseUpload(res) {
        try {
          this.companyinfo.license_id = res.id;
          this.companyinfo.license = res.pathname;
          setTimeout(() => this.form.setFieldsValue({ license: res.pathname }), 1);
          this.licenseocrres = await licenseocr(res.id);
          console.log(this.licenseocrres);
          let ocrrespick = pick(this.licenseocrres, [
            'address',
            'taxNumber',
            'owner',
            'legal_person',
          ]);
          setTimeout(() => {
            this.form.setFieldsValue({ 
              bidder: ocrrespick.owner,
              taxNumber: ocrrespick.taxNumber,
              companyAddress: ocrrespick.address
            });
          }, 1);
          this.companyinfo.address = ocrrespick.address;
          this.companyinfo.taxNumber = ocrrespick.taxNumber;
          this.companyinfo.legal_person = ocrrespick.legal_person;
          this.companyinfo.owner = ocrrespick.owner;
          // if (this.certocrres.owner && this.certocrres.owner != this.licenseocrres.owner) {
          //   this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
          // }
        } catch (error) {
          this.$message.error(error);
        }
      },
      async uploadFile(res, key) {
        try {
          this.pd[key] = res.pathname;
          this.pd[key + '_id'] = res.id;
          this.pd[key + '_name'] = res.filename;
          let ob = {};
          ob[key] = res.pathname;
          setTimeout(() => this.form.setFieldsValue(ob), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      validatePoundage(rule, value, callback) {
        if (value < this.minPoundage) {
          callback(`最低保费为${this.minPoundage}(元)`); 
        } else {
          callback(); 
        }
      },
      updatePoundage() {
        this.$nextTick(() => {
          const { money, temp_id, effect_month, rate, tempmoney } = this.form.getFieldsValue();
          if (
            money !== undefined && 
            temp_id !== undefined && 
            effect_month !== undefined
          ) {
            let pay = Math.ceil(parseFloat((money * effect_month * rate) / 1200));
            this.minPoundage = pay > tempmoney ? pay : tempmoney;
            this.form.setFieldsValue({ poundage: this.minPoundage });  
          }
        });
      },
      preStepupdata(ct) {
        if (ct.customize_temp_src != '') {
          this.stepRadioValue = 2;
          this.tempFlage = false;
        } else {
          this.stepRadioValue = 1;
          this.tempFlage = true;
        }
        let r_code = '';
        if (ct.p_user_id != 0) {
          r_code = String(ct.p_user_id);
        }
        this.fileinfo = {
          project_contract: ct.project_contract,
          project_contract_name: ct.project_contract_name,
          bidding_file: ct.bidding_file,
          bidding_file_name: ct.bidding_file_name,
          other_file: ct.other_file,
          other_file_name: ct.other_file_name
        }
        Object.assign(this.pd, ct);
        this.companyinfo.license = ct.company.license;
        this.companyinfo.certificate_src = ct.company.certificate_src;
        this.companyinfo.qualification_src = ct.company.qualification_src;
        this.companyinfo.id_card = ct.company.id_card;
        this.form.setFieldsValue({
          bidder: ct.bidder,
          taxNumber: ct.taxNumber,
          companyAddress: ct.companyAddress,
          tel: ct.company.tel,
          project: ct.project,
          landlord: ct.landlord,
          landlord_address: ct.landlord_address,
          proprietor: ct.proprietor,
          money: ct.money,
          category_id: ct.category_id,
          proprietor_address: ct.proprietor_address,
          kbdate: ct.kbdate,
          effect_month: ct.effect_month,
          temp_name: ct.temp_name,
          temp_id: ct.temp_id,
          customize_temp_src: ct.customize_temp_src,
          poundage: ct.poundage,
          r_code: r_code,
          sendName: ct.sendName,
          telephone: ct.telephone,
          rate: ct.rate,
          contract_amount: ct.contract_amount,
        });
      },
      async handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields(async (err, values) => {
          if (!err) {
            values.customize_temp_src = this.pd.customize_temp_src;
            this.companyinfo.tel = this.form.getFieldValue('tel');
            Object.assign(this.pd, values);
            try {
              this.spinning = true;
              // let res = await ggbCompanysava(this.companyinfo);
              // this.pd.comany_id = res;
              // if (!this.disabled) {
              //   this.pd.bankName = this.companyinfo.bankName;
              //   this.pd.bankAccount = this.companyinfo.bankAccount;
              //   this.pd.companyAddress = this.companyinfo.address;
              //   this.pd.legal_person = this.companyinfo.legal_person;
              // }
              const ct = await otherDoContract(this.pd);
              this.$emit('next', ct);
            } catch (error) {
              this.$message.error(error);
            } finally {
              this.spinning = false;
            }
          }
        });
      },
      async api2(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'customize_temp_src');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.$set(this.pd, 'customize_temp_src', res.pathname);
        this.$set(this.pd, 'customize_temp_id', res.id);
        this.loading = false;
        this.$message.success('上传成功');
      },
      beforeUpload(file) {
        const isLt = file.size / 1024 / 1024 < 50;
        if (!isLt) {
          this.$message.error('上传文件需小于50MB!');
          return false;
        }
        return isLt;
      },
      stepRadio(value) {
        if (value.target.value == 2) {
          this.tempFlage = false;
        } else {
          this.tempFlage = true;
        }
      },
      reset() {
        this.form.resetFields();
      },
      async companysearch(searchText) {
        if (searchText) {
          let res = await companysByProject(searchText);

          if (res) {
            this.companySearchs = res.map((e) => {
              return { text: e.owner, value: e.id.toString(), company: e };
            });
            res.forEach((e) => {
              if (e.owner == searchText) {
                this.disabled = true;
                console.log(1);
                this.form.setFieldsValue({
                  // company_name: e.owner,
                  taxNumber: e.taxNumber,
                  companyAddress: e.address,
                  tel: e.tel
                });
                this.pd.company_id = e.id;
                this.companyinfo = e;
              } else {
                this.disabled = false;
                this.form.setFieldsValue({
                  // company_name: '',
                  taxNumber: '',
                  companyAddress: '',
                  tel: ''
                });
                this.pd.company_id = 0;
                this.companyinfo = {};
              }
            });
          } else {
            this.companySearchs = [];
          }
        }
      },
      selectStepTempChange(value) {
        let temp = this.temp_data.find((e) => {
          return e.id == value;
        });
        this.pd.temp_id = value;
        this.form.setFieldsValue({
          rate: temp.rate,
          tempmoney: temp.money,
        });
        this.updatePoundage();
      },
      isdisabled(key) {
        if (!this.disabled) {
          return false;
        }
        return !!this.companyinfo[key];
      },
      companySelect({ key }) {
        let company = this.companySearchs.find((e) => {
          return e.value == key;
        }).company;
        this.form.setFieldsValue({
          // company_name: company.owner,
          taxNumber: company.taxNumber,
          bidder: company.owner,
          companyAddress: company.address,
          tel: company.tel
        });
        this.disabled = true;
        this.pd.company_id = company.id;
        this.companyinfo = company;
        // console.log(companyinfo);
        // this.form.setFieldsValue(this.companyinfo);
        this.form.setFieldsValue({ company: this.companyinfo });
      },
      qUpload(res) {
        console.log(res.pathname);

        // this.setTimeout(() => this.form.setFieldsValue({ qualification_src: res.pathname }), 1);
      },
    },
  };
</script>
<style lang="less" scoped>
  :deep(.ant-input-number) {
    float: right;
    width: 100%;
  }
  .scaled-upload {
    transform: scale(0.7);
    transform-origin: top left;
    width: 150%;
    margin-bottom: -28px;
  }
</style>
